import { solutions } from "./solutions";
import { words } from "./words";
export var combinedWords = solutions.concat(words);